// src/components/doctorsJournal/encryptionService.js
import CryptoJS from 'crypto-js';

const ENCRYPTION_CONFIG = {
  keySize: 256 / 32,
  iterations: 10000,
};

/**
 * Derives an encryption key from password and salt
 */
export const deriveKey = (password, salt) => {
  return CryptoJS.PBKDF2(password, salt, {
    keySize: ENCRYPTION_CONFIG.keySize,
    iterations: ENCRYPTION_CONFIG.iterations,
  }).toString();
};

/**
 * Encrypts text using AES-256
 */
export function encryptText(text, password) {
  const salt = generateSalt(); // Generate per-entry salt
  const key = deriveKey(password, salt);
  const ciphertext = CryptoJS.AES.encrypt(text, key).toString();
  return `${salt}:${ciphertext}`; // Prepend salt
}

/**
 * Decrypts text using AES-256
 */
export function decryptText(encryptedWithSalt, password) {
  const [salt, encrypted] = encryptedWithSalt.split(':');
  const key = deriveKey(password, salt);
  const decrypted = CryptoJS.AES.decrypt(encrypted, key);
  return decrypted.toString(CryptoJS.enc.Utf8);
}

/**
 * Generates a random salt
 */
export const generateSalt = () => {
  return CryptoJS.lib.WordArray.random(128 / 8).toString();
};

export async function hashPassword(password) {
  const encoder = new TextEncoder();
  const data = encoder.encode(password);
  const hashBuffer = await crypto.subtle.digest('SHA-256', data);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  return hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
}
